import type { CssGeneratorContext } from '../css-generator.model';

export const styles = ({ dt }: CssGeneratorContext) => `.app-event-group {
  & .group-header {
    color: ${dt('appEventGroup.groupHeader.color')};
    font-weight: ${dt('appEventGroup.groupHeader.fontWeight')};
    font-size: ${dt('appEventGroup.groupHeader.fontSize')};
    line-height: ${dt('appEventGroup.groupHeader.lineHeight')};
  }

  & .event-row {
    background: ${dt('appEventGroup.row.background')};
  }

  & .event-date {
    color: ${dt('appEventGroup.date.color')};
    font-weight: ${dt('appEventGroup.date.fontWeight')};
    font-size: ${dt('appEventGroup.date.fontSize')};
  }

  & .event-abbreviation {
    color: ${dt('appEventGroup.abbreviation.color')};
    font-weight: ${dt('appEventGroup.abbreviation.fontWeight')};
    font-size: ${dt('appEventGroup.abbreviation.fontSize')};
  }

  & .event-deadline {
    color: ${dt('appEventGroup.deadline.color')};
    font-size: ${dt('appEventGroup.deadline.fontSize')};
  }
}`;
